/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {useNavigate} from 'react-router-dom'
import {useTranslation} from 'react-i18next'
import swal from 'sweetalert'
import {withProtectedRoute} from '../../../utils/withProtectedRoute'
import {ApprovalOrder} from './ApprovalOrder'

export const WrapperAOrder: FC = withProtectedRoute(() => {
  const intl = useIntl()
  const {t} = useTranslation()

  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  const removeStorage = () => {
    localStorage.removeItem('credential')
    localStorage.removeItem('credential-decoded')
    localStorage.removeItem('cust-code')
    sessionStorage.removeItem('id')
    sessionStorage.removeItem('po')
    localStorage.removeItem('token')
    localStorage.removeItem('role-flag')
    localStorage.removeItem('dist')
    localStorage.removeItem('cust-group')
    sessionStorage.removeItem('SI_ID')
    localStorage.removeItem('namaUser')
    localStorage.removeItem('username')
    localStorage.removeItem('name')
    localStorage.removeItem('access')
    localStorage.removeItem('accesses')
    localStorage.removeItem('cust-grup')
    localStorage.removeItem('email')
    sessionStorage.removeItem('kid')
    sessionStorage.removeItem('order-detail-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sip')
    localStorage.removeItem('user-id')
    localStorage.removeItem('token')
    sessionStorage.removeItem('amandemen')
    localStorage.removeItem('cus-grup')
    localStorage.removeItem('idNews')
    sessionStorage.removeItem('jbp')
    sessionStorage.removeItem('jbp-id')
    localStorage.removeItem('role-id')
    localStorage.removeItem('sales-organization')
  }

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t('CONFIG.APPROVAL.ORDER.TITLE')}</PageTitle>
      <ApprovalOrder className='card-xxl-stretch mb-5 mb-xl-8' />
    </>
  )
})
